<template>
  <div class="flex justify-center items-center min-h-screen bg-gray-100">
    <div
      class="relative w-[320px] h-[500px] cursor-pointer [perspective:1200px]"
      @click="flipCard"
    >
      <div
        v-if="isRender"
        :class="[
          'relative w-full h-full transition-transform duration-700 [transform-style:preserve-3d]',
          isFlipped ? '[transform:rotateY(180deg)]' : '',
        ]"
      >
        <div
          class="absolute w-full h-full rounded-2xl overflow-hidden shadow-2xl [backface-visibility:hidden]"
        >
          <img
            :src="employee.idTemplate"
            alt="Company ID Front"
            class="w-full h-full object-cover"
          />

          <div
            class="absolute top-[220px] left-1/2 transform -translate-x-1/2 w-28 h-28 rounded-xl overflow-hidden border-4 border-white shadow-md"
          >
            <img
              :src="employee.photo"
              alt="Employee Photo"
              class="w-full h-full object-cover"
            />
          </div>
          <div
            class="absolute bottom-8 w-full text-center text-white drop-shadow-lg"
          >
            <p class="text-1xl font-bold italic">{{ employee.name }}</p>
          </div>

          <div class="absolute bottom-[130px] w-full text-center">
            <span
              class="inline-flex items-center px-4 py-1 text-sm font-semibold italic text-white rounded-full shadow-lg transition-all duration-300"
              :class="
                employee.status === 'A'
                  ? 'bg-emerald-500 shadow-emerald-400/50'
                  : 'bg-red-500 shadow-red-400/50'
              "
            >
              {{ employee.status === "A" ? "Active" : "Inactive" }}
            </span>
          </div>

          <div
            class="absolute bottom-12 w-full text-center"
            v-if="employee.status !== 'A'"
          >
            <p class="mt-5 text-sm text-gray-500 text-center p-5">
              <strong>
                Please do not transact with this account officer and report it @
                <a href="tel:85231649" class="text-blue-500 hover:underline"
                  >8523-1649</a
                >
                or contact
                <a
                  href="mailto:contact@iwc.com.ph"
                  class="text-blue-500 hover:underline"
                  >contact@iwc.com.ph</a
                >.
              </strong>
            </p>
          </div>
        </div>
        <div
          class="absolute w-full h-full bg-white text-gray-700 rounded-2xl border flex flex-col justify-center items-center shadow-2xl [transform:rotateY(180deg)] [backface-visibility:hidden]"
        >
          <p class="mt-5 text-sm text-gray-500 text-center p-5">
            <strong>
              For any questions / concerns, please call
              <a href="tel:85231649" class="text-blue-500 hover:underline"
                >8523-1649</a
              >
              or email
              <a
                href="mailto:contact@iwc.com.ph"
                class="text-blue-500 hover:underline"
                >contact@iwc.com.ph</a
              >.
            </strong>
          </p>
        </div>
      </div>
      <div v-else class="flex items-center justify-center w-full h-full">
        <span class="inline-flex items-center justify-center">
          <svg class="w-7 h-7 text-zinc-800 animate-spin" viewBox="0 0 24 24">
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
              fill="none"
            />
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import defaultIdTemplate from "@/assets/images/iwc-id.jpg";
import defaultUserPhoto from "@/assets/images/icon-user.jpg";

export default {
  setup() {
    const route = useRoute();
    const isFlipped = ref(false);
    const isRender = ref(false);
    const employee = ref({
      name: "Loading...",
      rank: "",
      company: "IMS Wellth Care, Inc.",
      contact: "",
      idTemplate: defaultIdTemplate,
      photo: defaultUserPhoto,
    });

    const flipCard = () => {
      isFlipped.value = !isFlipped.value;
    };

    const fetchAgentData = async () => {
      try {
        const publicId = route.params.id;
        const response = await axios.get(`/wb/general/agent/${publicId}`);
        const agent = response.data?.data?.[0];

        if (agent) {
          employee.value = {
            name: agent.agentname || "N/A",
            rank: agent.AgentRank || "Agent",
            company: agent.Branch || "IMS Wellth Care, Inc.",
            contact: agent.mobile || "N/A",
            idTemplate: defaultIdTemplate,
            photo: agent.photo_link || defaultUserPhoto,
            status: agent.Status,
          };
          setInterval(() => {
            isRender.value = true;
          }, 800);
        }
      } catch (error) {
        console.error("Error fetching agent data:", error);
      }
    };

    onMounted(() => {
      fetchAgentData();
    });

    return {
      isFlipped,
      flipCard,
      employee,
      isRender,
    };
  },
};
</script>
